import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/maximo-app-framework/maximo-autoscript-documentation/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Enterprise Services provide the inbound integration backbone of Maximo. They represent the internal implementation for all kinds of services that Maximo Integration Framework (MIF) offers,
XML/HTTP, SOAP, Flat Files, Interface tables to name a few. Enterprise services can optionally leverage the queues as it is async.`}<br parentName="p"></br>{`
`}{`Enterprise services are also used for Data import from UI as well as cron jobs (File, Interface Tables).
If the service is async, the Enterprise service execution starts after the messages get picked up from those queues and
get pushed downstream. Like its outbound equivalent (Publish Channel), Enterprise Services are used to transform data from external format to Maximo format, json or xml.`}<br parentName="p"></br>{`
`}{`Enterprise Services support the following script points:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Script Point`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`External Exits`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Used for data transformation of inbound messages from External format (`}<inlineCode parentName="td">{`erData`}</inlineCode>{`) to internal Maximo format `}<inlineCode parentName="td">{`irData`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`User Exit (Before External Exit)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Used for data modification before it reaches the External Exit (`}<inlineCode parentName="td">{`erData`}</inlineCode>{`).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`User Exit (After External Exit)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Used data transformation from the output of the External Exit to target Maximo format.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The following table lists the available variables:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Variable`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`erData`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An instance of psdi.iface.mic.StructureData used to hold the external document. Available for all three exits.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`irData`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An instance of psdi.iface.mic.StructureData used to hold the internal (Maximo format) document. This is set to null (as input) for External Exit and Before User Exit. External exits are expected to set the `}<inlineCode parentName="td">{`irData`}</inlineCode>{` by transforming the `}<inlineCode parentName="td">{`erData`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ifaceType`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The interface type name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ifaceName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The channel name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`osName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The Object Structure name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`messageType`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The message type which can have values like Sync/Create/Update/Delete.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`extSystem`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The external system name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`userInfo`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The UserInfo object representing the authenticated user that invoked this service.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`conn`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The jdbc Connection object.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The following example is of an after user exit script that sets the wopriority to an inbound WO transaction:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`if irData.getCurrentData("vendor")=="A0001" and irData.isCurrentDataNull("wopriority")==True:
  irData.setCurrentDataAsInt("wopriority",1)
`}</code></pre>
    <p>{`The “After User Exit” for Enterprise service would work with the `}<inlineCode parentName="p">{`irData`}</inlineCode>{` (internal Maximo format data)
as the inbound External exit would have mapped the external format to an internal format.
The following example is of a before user exit. In this example, the script decides to skip the transaction when a certain condition is met.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from org.jdom import Namespace

doc = erData.getData()
extXMLRoot = doc.getRootElement()
orgname = extXMLRoot.getChildText("orgname", Namespace.getNamespace("http://some_ns.org"))
if orgname=="somevalue":
  service.raiseSkipTransaction()
`}</code></pre>
    <p>{`The Before User Exit has access to only the `}<inlineCode parentName="p">{`erData`}</inlineCode>{` variable that contains the external document.
In this case the external document is XML and the API to access that as a JDOM document is `}<inlineCode parentName="p">{`erData.getData()`}</inlineCode>{`.
If this was a json document, you would need to use a different API to get the json data. The following script is an example of that:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from com.ibm.tivoli.maximo.oslc import OslcUtils
jsonData = OslcUtils.bytesToJSON(erData.getOriginalByteData())

orgname = jsonData.get("orgname")
if orgname=="somevalue":
  service.raiseSkipTransaction()
`}</code></pre>
    <p>{`The following example shows how to map a MAS User sync json with extension attributes (conforming to SCIM specification) to custom attributes for person record.
We will use an “after” User Exit script for the enterprise service MASPERUSER. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from com.ibm.tivoli.maximo.oslc import OslcUtils
from com.ibm.tivoli.maximo.oslc.provider import OslcJSONStructureData

byteData = irData.getDataAsBytes()
peruserJo = OslcUtils.bytesToJSONObject()
extJo = peruserJo.get("extension")
empNum = ""
if extJo is not None:
  empNum = extJo.get("employeeNumber")

#assume employeenumber as a custom attribute in person object  
peruserJo.put("employeenumber",empNum)

irData = OslcJSONStructureData(peruserJo, osName, None, userInfo, messageType, True)
`}</code></pre>
    <p>{`The following example is of an External Exit Script that creates a Maximo company by mapping external data to to MXVENDOR Object Structure:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from psdi.iface.mic import EnterpriseServiceCache
from psdi.server import MXServer
from org.jdom import Namespace

doc = erData.getData()
extXMLRoot = doc.getRootElement()
vendor = extXMLRoot.getChildText("vendor", Namespace.getNamespace("http://some_ns.org"))
organization = extXMLRoot.getChildText("organization", Namespace.getNamespace("http://some_ns.org"))
srv = EnterpriseServiceCache.getInstance().getEnterpriseServiceInfo("MXVENDORInterface")
changeBy = extXMLRoot.getChildText("user", Namespace.getNamespace("http://some_ns.org"))
irData = StructureData(srv.getMessageType(), srv.getMosName(), userInfo.getLangCode(), 1, false, false)
irData.setCurrentData("COMPANY", vendor)
irData.setCurrentData("ORGID", organization)
irData.setCurrentData("CHANGEBY", changeBy)
irData.setCurrentData("CHANGEDATE", MXServer.getMXServer().getDate())
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      